import { render, staticRenderFns } from "./VueTimeline.vue?vue&type=template&id=52924632&scoped=true&"
import script from "./VueTimeline.vue?vue&type=script&lang=js&"
export * from "./VueTimeline.vue?vue&type=script&lang=js&"
import style0 from "./VueTimeline.vue?vue&type=style&index=0&id=52924632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52924632",
  null
  
)

export default component.exports